import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { useContextSelector } from "use-context-selector";
import { ProfileSettingsContext } from "@/components/profile/ProfileSettingsProvider";
export const useProfileItemsColumnHeaders = () => {
  const $ = _c(37);
  const {
    showRarity
  } = useContextSelector(ProfileSettingsContext, _temp);
  const t = useTranslations("useProfileItemsColumnHeaders");
  let t0;
  if ($[0] !== t) {
    t0 = t("listingPrice");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      key: "listingPrice",
      header: t0,
      sortKey: "LISTING_OWN_PRICE"
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("rarity");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      key: "rarity",
      header: t2,
      sortKey: "RARITY"
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("floor");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = {
      key: "floor",
      header: t4,
      sortKey: "FLOOR_PRICE"
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("bestOffer");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("bestOfferTooltip");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = {
      key: "bestOffer",
      header: t6,
      sortKey: "TOP_OFFER",
      tooltip: t7
    };
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t("cost");
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t9) {
    t10 = {
      key: "cost",
      header: t9,
      sortKey: "COST"
    };
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t("received");
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11) {
    t12 = {
      key: "received",
      header: t11,
      sortKey: "RECEIVED_DATE"
    };
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t1 || $[28] !== t10 || $[29] !== t12 || $[30] !== t3 || $[31] !== t5 || $[32] !== t8) {
    t13 = [t1, t3, t5, t8, t10, t12];
    $[27] = t1;
    $[28] = t10;
    $[29] = t12;
    $[30] = t3;
    $[31] = t5;
    $[32] = t8;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  const columns = t13;
  let t14;
  if ($[34] !== columns || $[35] !== showRarity) {
    t14 = showRarity ? columns : columns.filter(_temp2);
    $[34] = columns;
    $[35] = showRarity;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  return t14;
};
function _temp(state) {
  return {
    showRarity: state.showRarity
  };
}
function _temp2(col) {
  return col.key !== "rarity";
}